var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getConfig } from '../common/config';
var responseHandler = function (response) {
    if (response.status === 401 || response.status === 403) {
        return Promise.resolve({ error: response.statusText });
    }
    return Promise.resolve(response.json());
};
export var featureApi = createApi({
    reducerPath: 'features',
    baseQuery: fetchBaseQuery({
        baseUrl: getConfig().apiUrlFeature,
        prepareHeaders: function (headers, _a) {
            var getState = _a.getState;
            var token = getState().auth.token;
            if (token) {
                headers.set('authorization', "Bearer ".concat(token));
            }
            else {
                console.error("No token set when calling Feature API");
            }
            headers.set('Content-Type', 'application/json');
            return headers;
        }
    }),
    tagTypes: ['Feature', 'TenantFeatureFlag', 'AdminFeatureFlag'],
    endpoints: function (builder) { return ({
        evaluateFeature: builder.mutation({
            query: function (context) { return ({
                url: "/api/v1/feature-flags/evaluation/resolve-boolean",
                method: 'POST',
                body: context,
                responseHandler: responseHandler
            }); },
            invalidatesTags: function () { return []; }
        }),
        getAdminFeatureFlags: builder.query({
            query: function () { return ({
                url: "/api/v1/admin/feature-flags",
                method: 'GET',
                responseHandler: responseHandler
            }); },
            providesTags: ['AdminFeatureFlag']
        }),
        createAdminFeatureFlag: builder.mutation({
            query: function (body) { return ({
                url: "/api/v1/admin/feature-flags",
                method: 'POST',
                body: body,
                responseHandler: 'text'
            }); },
            invalidatesTags: ['AdminFeatureFlag', 'TenantFeatureFlag']
        }),
        updateAdminFeatureFlag: builder.mutation({
            query: function (_a) {
                var flagKey = _a.flagKey, globallyEnabled = _a.globallyEnabled, description = _a.description;
                var body = {};
                if (globallyEnabled !== undefined)
                    body.globallyEnabled = globallyEnabled;
                if (description !== undefined)
                    body.description = description;
                return {
                    url: "/api/v1/admin/feature-flags/".concat(flagKey),
                    method: 'PATCH',
                    body: body,
                    responseHandler: 'text'
                };
            },
            onQueryStarted: function (_a, _b) {
                return __awaiter(this, arguments, void 0, function (_c, _d) {
                    var patchResult, _e;
                    var flagKey = _c.flagKey, globallyEnabled = _c.globallyEnabled, description = _c.description;
                    var dispatch = _d.dispatch, queryFulfilled = _d.queryFulfilled;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                patchResult = dispatch(featureApi.util.updateQueryData('getAdminFeatureFlags', undefined, function (draft) {
                                    if (draft[flagKey]) {
                                        if (globallyEnabled !== undefined)
                                            draft[flagKey].globallyEnabled = globallyEnabled;
                                        if (description !== undefined)
                                            draft[flagKey].description = description;
                                    }
                                }));
                                _f.label = 1;
                            case 1:
                                _f.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, queryFulfilled];
                            case 2:
                                _f.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                _e = _f.sent();
                                patchResult.undo();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            invalidatesTags: ['AdminFeatureFlag', 'TenantFeatureFlag']
        }),
        deleteAdminFeatureFlag: builder.mutation({
            query: function (flagKey) { return ({
                url: "/api/v1/admin/feature-flags/".concat(flagKey),
                method: 'DELETE',
                responseHandler: 'text'
            }); },
            invalidatesTags: ['AdminFeatureFlag', 'TenantFeatureFlag']
        }),
        getTenantFeatureFlags: builder.query({
            query: function () { return ({
                url: "/api/v1/tenant/feature-flags",
                method: 'GET',
                responseHandler: responseHandler
            }); },
            providesTags: ['TenantFeatureFlag']
        }),
        updateTenantFeatureFlag: builder.mutation({
            query: function (_a) {
                var flagKey = _a.flagKey, override = _a.override;
                return ({
                    url: "/api/v1/tenant/feature-flags/".concat(flagKey),
                    method: 'PUT',
                    body: { override: override },
                    responseHandler: 'text'
                });
            },
            onQueryStarted: function (_a, _b) {
                return __awaiter(this, arguments, void 0, function (_c, _d) {
                    var patchResult, _e;
                    var flagKey = _c.flagKey, override = _c.override;
                    var dispatch = _d.dispatch, queryFulfilled = _d.queryFulfilled;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                patchResult = dispatch(featureApi.util.updateQueryData('getTenantFeatureFlags', undefined, function (draft) {
                                    if (draft[flagKey]) {
                                        draft[flagKey].tenantOverride = override;
                                    }
                                }));
                                _f.label = 1;
                            case 1:
                                _f.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, queryFulfilled];
                            case 2:
                                _f.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                _e = _f.sent();
                                patchResult.undo();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            invalidatesTags: ['TenantFeatureFlag', 'AdminFeatureFlag']
        })
    }); }
});
export var useEvaluateFeatureMutation = featureApi.useEvaluateFeatureMutation, useGetTenantFeatureFlagsQuery = featureApi.useGetTenantFeatureFlagsQuery, useUpdateTenantFeatureFlagMutation = featureApi.useUpdateTenantFeatureFlagMutation, useGetAdminFeatureFlagsQuery = featureApi.useGetAdminFeatureFlagsQuery, useCreateAdminFeatureFlagMutation = featureApi.useCreateAdminFeatureFlagMutation, useUpdateAdminFeatureFlagMutation = featureApi.useUpdateAdminFeatureFlagMutation, useDeleteAdminFeatureFlagMutation = featureApi.useDeleteAdminFeatureFlagMutation;
